import { getPictureUrl } from 'core/api/pictures';
import { useSettings } from 'core/components/settingsContext';
import { title } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import React from 'react';
import PayButtonContainer from 'site/components/payments/PayButtonContainer';
import { IPayProductForm } from 'site/components/payments/PayButtonPresent';
import { ProductForm } from 'site/graphql';

type IProductSuggestedProductFormProps = {
    selectedProductForm: Pick<ProductForm, 'id' | 'suggestedTitle'> & {
        suggestedProductForm?: IPayProductForm & Pick<ProductForm, 'pictureId'>;
    };
} & WithStyles<typeof styles>;

const ProductSuggestedProductForm: React.StatelessComponent<IProductSuggestedProductFormProps> = ({
    selectedProductForm,
    classes,
}) => {
    const settings = useSettings();

    if (!(selectedProductForm && selectedProductForm.suggestedProductForm)) {
        return null;
    }

    const suggestedProductForm = selectedProductForm.suggestedProductForm;

    return (
        <div className={classes.root}>
            <h2 className={classes.title}>Рекомендуем</h2>
            <div
                className={classes.image}
                style={{
                    background: `url("${getPictureUrl(
                        suggestedProductForm.pictureId,
                        '370x180',
                        settings,
                    )}") center center / cover no-repeat`,
                }}
            />
            <div className={classes.suggestedTitle}>{selectedProductForm.suggestedTitle}</div>
            <PayButtonContainer productForm={suggestedProductForm} />
        </div>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        root: {
            marginTop: 1 + 'rem',
        },
        image: {
            height: 174,
            width: 'auto',
        },
        title: {
            ...title({ size: 'h2' }),
            marginBottom: 0.75 + 'rem',

            [theme.breakpoints.down('sm')]: {
                textAlign: 'center',
                fontSize: 1.25 + 'rem',
            },
        },
        suggestedTitle: {
            textAlign: 'center',
            fontSize: 0.95 + 'rem',
            fontWeight: 'bold',
            marginTop: 1 + 'rem',
            marginBottom: 1 + 'rem',
        },
    });

export default injectSheet(styles, 'ProductSuggestedProductForm')(ProductSuggestedProductForm);
